/* unplugin-vue-components disabled */import { render } from "./popup-chose-order.vue?vue&type=template&id=f1127110&scoped=true"
import script from "./popup-chose-order.vue?vue&type=script&lang=js"
export * from "./popup-chose-order.vue?vue&type=script&lang=js"

import "./popup-chose-order.vue?vue&type=style&index=0&id=f1127110&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1127110"]])

export default __exports__